import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "deleteButton"]

  connect() {
    this.updateDeleteButtonState()
  }

  updateState() {
    this.updateDeleteButtonState()
  }

  updateDeleteButtonState() {
    const checkedBoxes = this.checkboxTargets.filter(checkbox => checkbox.checked)
    this.deleteButtonTarget.disabled = checkedBoxes.length === 0
  }
}